import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLinkedin } from '@fortawesome/free-brands-svg-icons';
import { faEnvelope, faMobile, faFilePdf } from '@fortawesome/free-solid-svg-icons';
import '../App.css';

function Contact({ id }) {
  return (
    <section id={id}>
      <h2>Contact</h2>
      <div className="contact-info">
        <div className="contact-item">
          <FontAwesomeIcon icon={faLinkedin} className="contact-icon" />
          <a href="https://www.linkedin.com/in/antia-julia-alaman-martinez-92906ba0/" target="_blank" rel="noopener noreferrer">
            LinkedIn
          </a>
        </div>
        <div className="contact-item">
          <FontAwesomeIcon icon={faEnvelope} className="contact-icon" />
          <a href="mailto:alaman5martinez@gmail.com">alaman5martinez@gmail.com</a>
        </div>
        <div className="contact-item">
          <FontAwesomeIcon icon={faMobile} className="contact-icon" />
          <a href="tel:+34649701719">649701719</a>
        </div>
        <div className="contact-item">
          <FontAwesomeIcon icon={faFilePdf} className="contact-icon" />
          <a href="/cv/AntiaAlamanMartinezCV.pdf" download="AntiaAlamanMartinezCV.pdf"> {/* Corrected path */}
            Download CV
          </a>
        </div>
      </div>
    </section>
  );
}

export default Contact;
